import React, { useEffect, useState } from "react";
import "./TransportCommittee.css";
import { logHistory } from "../../utils/historyLogger";

function TransportCommittee() {
  const [data, setData] = useState([]);
  const role = localStorage.getItem("role");

  const canEdit = role === "admin" || role === "superadmin";
  const canDelete = role === "superadmin";
  // Any logged-in role (user, admin, superadmin) can add data now.
  const canAdd = role === "user" || role === "admin" || role === "superadmin";

  const [search, setSearch] = useState("");
  const [editingId, setEditingId] = useState(null);

  const [date, setDate] = useState("");
  const [request, setRequest] = useState("");
  const [requestedPerson, setRequestedPerson] = useState("");
  const [responsiblePerson, setResponsiblePerson] = useState("");
  const [solution, setSolution] = useState("");
  const [remark, setRemark] = useState("");
  const [status, setStatus] = useState("Pending");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(
        "https://hrpsc.swisstekaluminium.com/api/transportcommittee"
      );

      const result = await response.json();

      setData(Array.isArray(result) ? result : []);
    } catch (error) {
      console.log(error);
    }
  };

  const clearForm = () => {
    setDate("");
    setRequest("");
    setRequestedPerson("");
    setResponsiblePerson("");
    setSolution("");
    setRemark("");
    setStatus("Pending");
    setEditingId(null);
  };
    const handleSubmit = async () => {
    try {
      const newData = {
        date,
        request,
        requestedPerson,
        responsiblePerson,
        solution,
        remark,
        status,
      };

      let response;

      if (editingId) {
        response = await fetch(
          `https://hrpsc.swisstekaluminium.com/api/transportcommittee/${editingId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(newData),
          }
        );

        if (!response.ok) {
          throw new Error("Update Failed");
        }

        await logHistory(
          "Transport Committee",
          "Updated Transport Committee Record",
          "Transport committee record updated"
        );

        alert("Updated Successfully");
      } else {
        response = await fetch(
          "https://hrpsc.swisstekaluminium.com/api/transportcommittee",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(newData),
          }
        );

        if (!response.ok) {
          throw new Error("Save Failed");
        }

        await logHistory(
          "Transport Committee",
          "Added Transport Committee Record",
          "Transport committee record added"
        );

        alert("Added Successfully");
      }

      fetchData();
      clearForm();
    } catch (error) {
      console.log(error);
      alert("Error Saving Data");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this transport committee record?")) return;

    try {
      const response = await fetch(
        `https://hrpsc.swisstekaluminium.com/api/transportcommittee/${id}`,
        {
          method: "DELETE",
        }
      );

      if (!response.ok) {
        throw new Error("Delete Failed");
      }

      await logHistory(
        "Transport Committee",
        "Deleted Transport Committee Record",
        "Transport committee record deleted"
      );

      fetchData();
      alert("Deleted Successfully");
    } catch (error) {
      console.log(error);
      alert("Delete Failed");
    }
  };

  const handleEdit = (item) => {
    setEditingId(item.id);
    setDate(item.date || "");
    setRequest(item.request || "");
    setRequestedPerson(item.requestedPerson || "");
    setResponsiblePerson(item.responsiblePerson || "");
    setSolution(item.solution || "");
    setRemark(item.remark || "");
    setStatus(item.status || "Pending");

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const downloadCSVReport = () => {
    if (data.length === 0) {
      alert("No transport committee data to download");
      return;
    }

    const headers = Object.keys(data[0]);

    const rows = data.map((item) =>
      headers
        .map((field) => `"${String(item[field] ?? "").replace(/"/g, '""')}"`)
        .join(",")
    );

    const csvContent = [headers.join(","), ...rows].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "transport_committee_report.csv";
    link.click();

    URL.revokeObjectURL(url);
  };

  const filteredData = data.filter(
    (item) =>
      item.request?.toLowerCase().includes(search.toLowerCase()) ||
      item.requestedPerson?.toLowerCase().includes(search.toLowerCase()) ||
      item.responsiblePerson?.toLowerCase().includes(search.toLowerCase())
  );

  const totalRequests = data.length;

  const pendingCount = data.filter((item) => item.status === "Pending").length;

  const solvedCount = data.filter((item) => item.status === "Solved").length;
    return (
    <div className="transport-page">
      <h1 className="page-title">Transport Committee</h1>

      <div className="dashboard-cards">
        <div className="dashboard-card">
          <h3>Total Requests</h3>
          <h1>{totalRequests}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Pending</h3>
          <h1>{pendingCount}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Solved</h3>
          <h1>{solvedCount}</h1>
        </div>
      </div>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <button className="clear-btn" onClick={() => setSearch("")}>
          Clear
        </button>

        <button className="add-btn" onClick={downloadCSVReport}>
          Download Report
        </button>
      </div>

      {(canAdd || editingId) && (
        <div className="form-container">
          <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />

          <input
            type="text"
            placeholder="Request"
            value={request}
            onChange={(e) => setRequest(e.target.value)}
          />

          <input
            type="text"
            placeholder="Requested Person"
            value={requestedPerson}
            onChange={(e) => setRequestedPerson(e.target.value)}
          />

          <input
            type="text"
            placeholder="Responsible Person"
            value={responsiblePerson}
            onChange={(e) => setResponsiblePerson(e.target.value)}
          />

          <input
            type="text"
            placeholder="Solution"
            value={solution}
            onChange={(e) => setSolution(e.target.value)}
          />

          <input
            type="text"
            placeholder="Remark"
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          />

          <select value={status} onChange={(e) => setStatus(e.target.value)}>
            <option>Pending</option>
            <option>Solved</option>
          </select>

          <button className="add-btn" onClick={handleSubmit}>
            {editingId ? "Update" : "Add Request"}
          </button>

          <button className="clear-btn" onClick={clearForm}>
            Clear Form
          </button>
        </div>
      )}

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Request</th>
              <th>Requested Person</th>
              <th>Responsible Person</th>
              <th>Solution</th>
              <th>Remark</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredData.map((item) => (
              <tr key={item.id}>
                <td>{item.date}</td>
                <td>{item.request}</td>
                <td>{item.requestedPerson}</td>
                <td>{item.responsiblePerson}</td>
                <td>{item.solution}</td>
                <td>{item.remark}</td>

                <td>
                  <span
                    className={
                      item.status === "Solved"
                        ? "status-solved"
                        : "status-pending"
                    }
                  >
                    {item.status}
                  </span>
                </td>

                <td>
                  {canEdit && (
                    <button
                      className="edit-btn"
                      onClick={() => handleEdit(item)}
                    >
                      Edit
                    </button>
                  )}

                  {canDelete && (
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(item.id)}
                    >
                      Delete
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TransportCommittee;